import userInfo from "../../function/userInfo";
import * as API from "../ApiConfig";
import transactionHelper from "../transaction/transactionHelper";
import helper from "./journalHelper";
export default {
  DoCreateJournal(status, journal) {
    let _input = helper.GetCreateJournalInput(status, journal);
    return API.peakRealTimeAPIForTransaction
      .post("/api/Journal/CreateJournal", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateJournal(journal) {
    let _input = {
      journal: helper.GetUpdateJournalInput(journal),
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Journal/EditJournal", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetSuggestJournalNumber(date, journalType) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      date: date,
      journalType: journalType,
    };
    return API.peakRealTimeAPI
      .post("/api/Journal/GetSuggestJournalNumber", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetJournalDetail(id) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      id: id,
    };
    return API.peakRealTimeAPI
      .post("/api/Journal/GetJournalDetail", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateJournalLockStatus(journalInput) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      journalId: journalInput.journalId,
      referenceId: journalInput.referenceId,
      referenceTypeId: journalInput.referenceTypeId,
      paymentReferenceId: journalInput.paymentReferenceId,
      lockStatusId: journalInput.lockStatusId,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Journal/UpdateJournalLockStatus", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetReferencedJournalByTransaction(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      financetypeId: input.financeTypeId,
      transactionType: input.transactionTypeId,
      transactionId: input.transactionId,
    };
    return API.peakRealTimeAPI
      .post("/api/Journal/GetReferencedJournalByTransaction", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetJournalFile(journalId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      journalId: journalId,
    };
    return API.peakRealTimeAPI.post("/api/File/GetJournalFile", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoUploadJournalFile(input) {
    let formData = new FormData();
    formData.append("merchantId", userInfo.MerchantId());
    formData.append("journalId", input.journalId);
    input.fileList.forEach((file, index) => {
      let blob = transactionHelper.Base64ToBlob(file.rawString, file.fileType);
      formData.append(`fileList[${index}]`, blob, file.fileName);
    });
    return API.peakRealTimeAPIForImport
      .post("/api/Journal/UploadJournalFile", formData, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoDeleteJournalFile(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      journalId: input.journalId,
      fileList: input.fileList,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Journal/DeleteJournalFile", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetJournalTagByJournalId(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      journalId: input.journalId,
    };
    return API.peakRealTimeAPI
      .post("/api/Tag/GetJournalTagByJournalId", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoInsertTagJournal(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      journalId: input.journalId,
      tagId: input.tagId,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Journal/InsertTagJournal", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUnattachTagJournal(tagJournalId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      tagJournalId: tagJournalId,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Journal/UnattachTagJournal", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetReceivedTaxInvoiceForJournalDetail(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      referenceId: input.referenceId,
      referenceType: input.referenceType,
    };
    return API.peakRealTimeAPI
      .post("/api/Transaction/GetReceivedTaxInvoiceForJournalDetail", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoVoidJournalByJournalId(journalId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      journalId: journalId,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Journal/VoidJournalByJournalId", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetJournalActivityLog(journalId) {
    const headers = userInfo.SetHeaderService().headers;
    const params = {
      merchantId: userInfo.MerchantId(),
      journalId: journalId,
    };
    return API.peakLogAPI.get("/api/ActivityLog/GetJournalActivityLog", { params, headers }).then((res) => {
      return res;
    });
  },
  DoReInsertJournalAllocation(journalIdList) {
    let _input = {
      journalIdList: journalIdList,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Journal/ReInsertJournalAllocation", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetJournalViewDetailList(journalIdList) {
    let _input = {
      journalIdList: journalIdList,
    };
    return API.peakAPI
      .post("/api/Journal/GetJournalViewDetailList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
};
